module.exports = __webpack_public_path__ + "img/edit.e333eda4.svg";